import React from 'react';
export function Navbar() {
  return <nav className="fixed top-0 left-0 right-0 bg-white/90 backdrop-blur-md z-50 border-b border-gray-100" data-id="element-132">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-133">
        <div className="flex items-center gap-2" data-id="element-134">
          <div className="w-8 h-8 bg-navy rounded flex items-center justify-center" data-id="element-135">
            <span className="text-white font-bold text-lg leading-none" data-id="element-136">
              EE
            </span>
          </div>
          <span className="font-bold text-navy text-lg tracking-tight hidden sm:block" data-id="element-137">
            Entrevistas Espectaculares
          </span>
        </div>
        <a href="#offer" className="bg-emerald text-white px-5 py-2 rounded-md font-medium text-sm hover:bg-emerald-hover transition-colors" data-id="element-138">
          Obtener Guía
        </a>
      </div>
    </nav>;
}